var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{attrs:{"fluid":""}},[_c('div',{staticClass:"display-2 font-weight-thick",staticStyle:{"text-align":"left"},attrs:{"color":"white"}},[_vm._v("test")])])}
var staticRenderFns = []

export { render, staticRenderFns }